import {
  GLASSMORPHIC_LIBRARY_IMAGES,
  resolveGlassmorphicLibraryImage,
  type MarketingImageAsset,
} from '@glonextrack/contracts';

export const PAGE_HERO_IMAGES = {
  home: {
    src: '/images/marketing/home-landing-fleet-telematics-intelligence.jpg',
    alt: 'fleet telematics intelligence platform',
  },
  features: {
    src: '/images/marketing/features-overview-telematics-platform-features.jpg',
    alt: 'telematics platform features',
  },
  insuranceUbi: {
    src: '/images/marketing/industry-insurance-ubi-usage-based-insurance-telematics.jpg',
    alt: 'usage-based insurance telematics',
  },
  ambulanceEmergency: {
    src: '/images/marketing/industry-ambulance-emergency-fleet-tracking.jpg',
    alt: 'ambulance emergency fleet tracking',
  },
  livestockFarming: {
    src: '/images/marketing/industry-livestock-farming-livestock-gps-tracking.jpg',
    alt: 'livestock GPS tracking',
  },
  fleetManagementIndustry: {
    src: '/images/marketing/industry-fleet-management-solutions.jpg',
    alt: 'fleet management solutions',
  },
  logisticsIndustry: {
    src: '/images/marketing/industry-logistics-supply-chain-tracking.jpg',
    alt: 'logistics supply chain tracking',
  },
  gadgets: {
    src: '/images/marketing/gadgets-gps-trackers-iot-devices.jpg',
    alt: 'GPS trackers and IoT devices',
  },
  contact: {
    src: '/images/marketing/contact-glonextrack-fleet-intelligence.jpg',
    alt: 'contact fleet intelligence',
  },
  whiteLabel: {
    src: '/images/marketing/feature-white-label-white-label-telematics-platform.jpg',
    alt: 'white-label telematics platform',
  },
  pricing: {
    src: '/images/marketing/pricing-fleet-management-subscriptions.jpg',
    alt: 'fleet management subscriptions',
  },
  about: {
    src: '/images/marketing/about-glonextrack-telematics-company.jpg',
    alt: 'telematics company',
  },
  mobileApp: {
    src: '/images/marketing/mobile-app-page-mobile-gps-tracking.jpg',
    alt: 'mobile GPS tracking app',
  },
  tenantLanding: {
    src: '/images/marketing/tenant-landing-white-label-fleet-brand-page.jpg',
    alt: 'white-label fleet brand page',
  },
} as const;

export const FEATURE_HERO_IMAGES = {
  'live-tracking': {
    src: '/images/marketing/feature-live-tracking-real-time-gps-tracking.jpg',
    alt: 'real-time GPS tracking',
  },
  'fleet-management': {
    src: '/images/marketing/feature-fleet-management-fleet-management-software.jpg',
    alt: 'fleet management software',
  },
  'camera-intelligence': {
    src: '/images/marketing/feature-camera-intelligence-ai-dashcam-video-telematics.jpg',
    alt: 'AI dashcam video telematics',
  },
  'ai-copilot': {
    src: '/images/marketing/feature-ai-copilot-ai-fleet-management.jpg',
    alt: 'AI fleet management',
  },
  geofencing: {
    src: '/images/marketing/feature-geofencing-gps-geofencing-software.jpg',
    alt: 'GPS geofencing software',
  },
  'driver-safety': {
    src: '/images/marketing/feature-driver-safety-driver-safety-scoring.jpg',
    alt: 'driver safety scoring',
  },
  'reports-analytics': {
    src: '/images/marketing/feature-reports-analytics-fleet-reports-analytics.jpg',
    alt: 'fleet reports analytics',
  },
  'device-hub': {
    src: '/images/marketing/feature-device-hub-iot-device-management.jpg',
    alt: 'IoT device management',
  },
  'billing-subscriptions': {
    src: '/images/marketing/feature-billing-subscriptions-fleet-billing-software.jpg',
    alt: 'fleet billing software',
  },
  'notifications-alerts': {
    src: '/images/marketing/feature-notifications-alerts-fleet-alert-system.jpg',
    alt: 'fleet alert system',
  },
  'white-label': {
    src: '/images/marketing/feature-white-label-white-label-telematics-platform.jpg',
    alt: 'white-label telematics platform',
  },
  'mobile-app': {
    src: '/images/marketing/feature-mobile-app-fleet-management-mobile-app.jpg',
    alt: 'fleet management mobile app',
  },
} as const;

export const FEATURE_SECTION_IMAGES = {
  deepDive: {
    src: '/images/marketing/section-deep-dive-feature-explanation-glassmorphic.jpg',
    alt: 'feature explanation',
  },
  subFunctions: {
    src: '/images/marketing/section-sub-functions-feature-modules-glassmorphic.jpg',
    alt: 'feature modules',
  },
  capabilities: {
    src: '/images/marketing/section-capabilities-key-capabilities-glassmorphic.jpg',
    alt: 'key capabilities',
  },
  caseStudy: {
    src: '/images/marketing/section-case-study-customer-impact-glassmorphic.jpg',
    alt: 'customer impact case study',
  },
  cta: {
    src: '/images/marketing/section-cta-conversion-glassmorphic.jpg',
    alt: 'conversion call to action',
  },
} as const;

export const HOME_SECTION_IMAGES = {
  trustedBy: {
    src: '/images/marketing/marketing-trusted-by-leaders-partner-network.jpg',
    alt: 'partner network',
  },
  industries: {
    src: '/images/marketing/landing-section-industries-telematics-solutions.jpg',
    alt: 'telematics solutions',
  },
  hardware: {
    src: '/images/marketing/landing-section-hardware-iot-gadgets-portfolio.jpg',
    alt: 'IoT gadgets portfolio',
  },
  whiteLabel: {
    src: '/images/marketing/landing-section-white-label-brand-platform.jpg',
    alt: 'white-label brand platform',
  },
  cta: {
    src: '/images/marketing/landing-section-cta-start-free-trial-fleet-platform.jpg',
    alt: 'start free trial fleet platform',
  },
} as const;

export {
  GLASSMORPHIC_LIBRARY_IMAGES,
  resolveGlassmorphicLibraryImage,
  type MarketingImageAsset,
};
